module.exports = __webpack_public_path__ + "static/media/tob_web.96951bad.svg";